import alphabetBook from './components/alphabetBook.vue';


export default {
  routes: [
    {
      path: '/',
      component:alphabetBook,
      name:'alphabetBook'
    },

  ]
};
